module.exports = __webpack_public_path__ + "media/images/footer/gga-4bf92d1b8a1cb54a14e2d135c40e0918.png";